import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

type PagerPageSizeProps = {
  navigate: (newParams: { [key: string]: any }) => void;
  pageSize: number;
  paramName: string;
  defaultPageSize: number;
  pageSizes: number[];
};

export const ResponsePagerPageSize: React.FC<PagerPageSizeProps> = ({
  navigate,
  pageSize,
  paramName,
  defaultPageSize,
  pageSizes,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    navigate({
      // if we asking for default page size, then just clear out the parameter
      [paramName]:
        event.target.value === String(defaultPageSize)
          ? undefined
          : event.target.value,
    });
  };

  return (
    <span>
      &nbsp;
      <Button
        aria-controls="page-size-filter"
        aria-haspopup="true"
        onClick={handleMenuOpen}
        data-test="page-size-filter"
      >
        {pageSize}
      </Button>
      <Menu
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        id="page-size-filter"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        className="UserMenu"
      >
        <RadioGroup
          aria-label="status"
          name="status"
          value={pageSize}
          onChange={handleChange}
        >
          {pageSizes.map((pageSize) => (
            <MenuItem key={pageSize}>
              <FormControlLabel
                value={pageSize}
                control={
                  <Radio data-test={`items-per-page-selector-${pageSize}`} />
                }
                label={pageSize}
                data-test="menu-item-page-size"
              />
            </MenuItem>
          ))}
        </RadioGroup>
      </Menu>
    </span>
  );
};
